import { render, staticRenderFns } from "./UserAction.vue?vue&type=template&id=575d71ef&scoped=true&"
import script from "./UserAction.vue?vue&type=script&lang=js&"
export * from "./UserAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575d71ef",
  null
  
)

export default component.exports